<oth-card [bodyTemplate]="bodyTemplate" class="contact-information-card">
  <!-- Body -->
  <ng-template #bodyTemplate>
    <div class="body">
      <div *ngIf="CONTACT_INFO.phone" class="info-line">
        <p class="title"><i aria-hidden="true" class="fas fa-phone"></i></p>
        <a [href]="'tel:' + CONTACT_INFO.phone" class="info">{{
          CONTACT_INFO.phone
          }}</a>
      </div>
      <div *ngIf="CONTACT_INFO.email" class="info-line">
        <p class="title"><i aria-hidden="true" class="fas fa-envelope"></i></p>
        <a [href]="'mailto:' + CONTACT_INFO.email" class="info">{{
          CONTACT_INFO.email
          }}</a>
      </div>
      <div *ngIf="CONTACT_INFO.address" class="info-line">
        <p class="title">
          <i aria-hidden="true" class="fas fa-map-marker-alt"></i>
        </p>
        <a [href]="CONTACT_INFO.map" class="info" target="_blank">{{ CONTACT_INFO.address }}</a>
      </div>
      <div class="map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.3084039737073!2d78.483464!3d17.444947000000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9a0e86cb1f93%3A0x389bdbbfa2fd9dc!2sS%20R%20Group!5e0!3m2!1sen!2sin!4v1750052276917!5m2!1sen!2sin"
          width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>

    </div>
  </ng-template>
</oth-card>